<template>
  <v-expansion-panels 
    v-if="!!contract.paymentPlan"
    multiple 
    flat
    class="border mb-2"
    :value="keepOpen" 
    >
    <v-expansion-panel >
      <v-expansion-panel-header 
        ripple 
        expand-icon="mdi-chevron-down"
        class="text-h6"
        >
        {{ $t('contract.show.panel_two.title') }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-list-item 
          class="px-0"
          two-line>
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('contract.show.panel_two.items.fee') }}</v-list-item-subtitle>
            <v-list-item-title>
              {{ fee.prices.length }} cuotas de ${{ fee.prices[0].amount }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
          class="px-0"
          two-line>
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('contract.show.panel_two.items.payment_methods') }}</v-list-item-subtitle>
            <v-list-item-title>
              <span
                :key="paymentMethod.id"
                v-for="(paymentMethod, idx) in contract.paymentPlan.paymentMethods">
                {{ paymentMethod + ((idx + 1) == contract.paymentPlan.paymentMethods.length ? '' : ', ') }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name:"PanelTwo",
  data(){
    return {
      keepOpen: [0]
    }
  },
  props: ['contract'],
  computed: {
    fee () {
      return this.contract.paymentPlan.taxes.find( t => t.name == 'Honorarios' )
    }
  }
}
</script>
